import request from '@/utils/request'

// 激活码

let UserRoleApi = {

  /*列表*/
  getList(data, errorback) {
    return request._post('/shop/study.user_role/index', data, errorback);
  },

  /*添加*/
  add(data, errorback) {
    return request._post('/shop/study.user_role/add', data, errorback);
  },

  /*删除*/
  del(data, errorback) {
    return request._post('/shop/study.user_role/del', data, errorback);
  },

  /*编辑*/
  edit(data, errorback) {
    return request._post('/shop/study.user_role/edit', data, errorback);
  },
  
  /*分类*/
  category(data, errorback) {
    return request._post('/shop/study.user_role/category', data, errorback);
  },

  /*取用户权限范围*/
  roleIds(data, errorback) {
    return request._post('/shop/study.user_role/roleIds', data, errorback);
  },
}

export default UserRoleApi;



// WEBPACK FOOTER //
// ./src/api/study/user_role.js